import { getConfig } from '../Config/ApplicationConfig';
import { Permission } from '../Config/PermissionConfig';
import { getExecutor, IGuidResult } from '../Shared/HttpRequestExecutor';
import {
    GroupICreateNewGroup,
    GroupIEditGroup,
    GroupIEditParentGroups,
    GroupIGroup,
    GroupIGroupMember,
    GroupIGroupPermissions,
    GroupIParentGroup,
    GroupIReplaceMembersInGroup,
    PermissionsIPermission,
    UserICreateNewUser,
    UserIEditParentGroups,
    UserIEditUser,
    UserIParentGroup,
    UserIReplaceUserPermissions,
    UserIUser,
    UserIUserPermissions
} from './AuthorisationModels';

export function getUsers(query = '', activeOnly = false, limit = 50): Promise<UserIUser[]> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<UserIUser[]>(
        `api/v1/users/search?query=${query}&activeOnly=${activeOnly}&limit=${limit}`
    );
}

export function getUserPermissions(id: string): Promise<UserIUserPermissions> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<UserIUserPermissions>(
        `api/v1/users/${id}/permissions`
    );
}

export function updateUserPermissions(id: string, permissions: UserIReplaceUserPermissions): Promise<IGuidResult> {
    return getExecutor(getConfig().apiEndpoints.authorisation).put<UserIReplaceUserPermissions, IGuidResult>(
        `api/v1/users/${id}/permissions/all`,
        permissions
    );
}

export function getCurrentPermissions(): Promise<Permission[]> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<PermissionsIPermission[]>(
        `api/v1/users/me/permissions`
    );
}

export function getCurrentUser(): Promise<UserIUser> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<UserIUser>(`api/v1/users/me`);
}

export function getSystemContact(): Promise<UserIUser> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<UserIUser>(`api/v1/users/system-contact/`);
}

export function getUserById(id: string): Promise<UserIUser> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<UserIUser>(`api/v1/users/${id}`);
}

export function createUser(queryObject: UserICreateNewUser): Promise<IGuidResult> {
    return getExecutor(getConfig().apiEndpoints.authorisation).post<UserICreateNewUser, IGuidResult>(
        `api/v1/users/`,
        queryObject
    );
}

export function updateUser(id: string, queryObject: UserIEditUser): Promise<IGuidResult> {
    return getExecutor(getConfig().apiEndpoints.authorisation).put<UserIEditUser, IGuidResult>(
        `api/v1/users/${id}`,
        queryObject
    );
}

export function getUsersParentGroups(id: string): Promise<UserIParentGroup[]> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<UserIParentGroup[]>(
        `api/v1/users/${id}/groups/parents`
    );
}

export function updateUsersParentGroups(id: string, data: UserIEditParentGroups): Promise<IGuidResult> {
    return getExecutor(getConfig().apiEndpoints.authorisation).put<UserIEditParentGroups, IGuidResult>(
        `api/v1/users/${id}/groups/parents`,
        data
    );
}

export function getGroups(query = '', activeOnly = false, limit = 50): Promise<GroupIGroup[]> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<GroupIGroup[]>(
        `api/v1/groups/search?query=${query}&activeOnly=${activeOnly}&limit=${limit}`
    );
}

export function getGroupById(id: string): Promise<GroupIGroup> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<GroupIGroup>(`api/v1/groups/${id}`);
}

export function getGroupPermissions(id: string): Promise<GroupIGroupPermissions> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<GroupIGroupPermissions>(
        `api/v1/groups/${id}/permissions`
    );
}

export function getDefaultGroup(): Promise<GroupIGroup> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<GroupIGroup>(`api/v1/groups/default`);
}

export function getGroupsParentGroups(id: string): Promise<GroupIParentGroup[]> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<GroupIParentGroup[]>(`api/v1/groups/${id}/parents`);
}

export function getGroupsGroupMembers(id: string): Promise<GroupIGroupMember[]> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<GroupIGroupMember[]>(`api/v1/groups/${id}/members`);
}

export function createGroup(queryObject: GroupICreateNewGroup): Promise<IGuidResult> {
    return getExecutor(getConfig().apiEndpoints.authorisation).post<GroupICreateNewGroup, IGuidResult>(
        `api/v1/groups/`,
        queryObject
    );
}

export function updateGroup(id: string, queryObject: GroupIEditGroup): Promise<IGuidResult> {
    return getExecutor(getConfig().apiEndpoints.authorisation).put<GroupIEditGroup, IGuidResult>(
        `api/v1/groups/${id}`,
        queryObject
    );
}

export function deleteGroup(groupId: string): Promise<Response> {
    return getExecutor(getConfig().apiEndpoints.authorisation).delete(`api/v1/groups/${groupId}`);
}

export function updateGroupMembers(id: string, queryObject: GroupIReplaceMembersInGroup): Promise<IGuidResult> {
    return getExecutor(getConfig().apiEndpoints.authorisation).put<GroupIReplaceMembersInGroup, IGuidResult>(
        `api/v1/groups/${id}/members`,
        queryObject
    );
}

export function updateGroupParentGroups(id: string, queryObject: GroupIEditParentGroups): Promise<IGuidResult> {
    return getExecutor(getConfig().apiEndpoints.authorisation).put<GroupIEditParentGroups, IGuidResult>(
        `api/v1/groups/${id}/parents`,
        queryObject
    );
}
